import { takeLeading } from 'redux-saga/effects';
import { get } from 'lodash';
import { callApi } from 'helpers/saga-helpers';
import userToken from 'containers/services/security/access-token-storage';
import { REQUEST_SET_PRIVILEGES_MANAGER } from 'containers/ManagerManagement/constant';

export function* requestSetPrivilegesManager(action: any): Generator {
  const { payload, successCallback } = action;
  const token = get(userToken.get(), 'token');
  if (!token) return;
  const path = `/corporeal/user-privileges`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...payload,
    }),
  };
  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
  }
}

export function* requestSetPrivilegesManagerSaga() {
  yield takeLeading(
    REQUEST_SET_PRIVILEGES_MANAGER,
    requestSetPrivilegesManager,
  );
}

export default [requestSetPrivilegesManagerSaga];
